// Hook + shared context for the global toast provider in Toast.jsx.
//
// Split into its own file so the Toast.jsx module exports only a
// component — otherwise Vite's Fast Refresh shuts off for that module
// (react-refresh/only-export-components). Consumers just import
// `useToast` from here; the provider is still mounted from Toast.jsx.
import { createContext, useContext } from 'react'

export const ToastContext = createContext(null)

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) {
    // Safe fallback for components rendered outside the provider
    // (Storybook, isolated unit tests, or a forgotten mount). The
    // codebase spent a sprint killing native window.alert calls —
    // surfacing one from a missing provider would be a silent
    // regression. Log a dev warning and drop the message instead.
    return {
      showToast: (message) => {
        if (message) console.warn('[useToast] no ToastProvider mounted:', message)
      },
      dismissToast: () => {},
    }
  }
  return ctx
}
